import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "sirod_token";

// Auth strategy:
//   • Production (same-origin via Emergent ingress) — backend sets an httpOnly cookie on verify-otp.
//     Cookies travel via `withCredentials: true` and are XSS-safe (JS cannot read httpOnly).
//   • Preview / cross-origin — ingress forces Access-Control-Allow-Origin: '*', which the browser
//     refuses to combine with credentials, so cookies can't reach the backend. We fall back to a
//     short-lived JWT in sessionStorage. sessionStorage is per-tab and clears on close — much smaller
//     XSS blast radius than localStorage. Tokens expire after 8 hours.
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  withCredentials: false, // ingress forces ACAO:* during preview, so omit credentials
});

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/login") && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
